import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbilityBackward extends BaseModelAPI {
	static entity = 'newreport2134';
	static entityName = 'reporttracingabilitybackward';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterControlCardId = '';
		this.filterPartNumber = '';
		this.filterWopNumber = '';
		this.filterLotNo = '';
		this.filterProdDate = '';
		this.filterFinishDate = '';
		this.tempId = 0;
		this.controlCardProduction = '';
		this.partNumberProduksi = '';
		this.materialSource = '';
		this.partNumberSource = '';
		this.lotNo = '';
		this.wopNumber = '';
		this.productionDate = '';
		this.finishProductionDate = '';
		this.controlCardRepair = '';
		this.controlCardCombineCase = '';
		this.controlCardFqQc = '';
		this.controlCardRepacking = '';
		this.changeFrom = '';
		this.machine = '';
		this.operatorUser = '';
		this.shift = '';
		this.qtyBefore = 0;
		this.qtyAfter = 0;
		this.qtyTaken = 0;
		this.controlCardNumber = '';
		this.controlCardType = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}